import '@/styles/app.css'

import { instalarMensagensZod } from '@projetive-op/domain'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import superjson from 'superjson'

import { iniciarPwa } from '@/lib/pwa'
import {
  MAX_IDADE_CACHE_MS,
  VERSAO_CACHE,
  criarQueryClient,
  deveGuardarNoAparelho,
} from '@/lib/query-client'
import { TRPCProvider, criarTrpcClient } from '@/lib/trpc'
import { routeTree } from '@/routeTree.gen'

// Antes de qualquer validação: as mesmas mensagens da API (packages/domain).
instalarMensagensZod()
// Cedo, antes do React: o convite de instalação do Chrome chega uma vez só.
iniciarPwa()

const queryClient = criarQueryClient()
const trpcClient = criarTrpcClient()
const persister = createSyncStoragePersister({
  storage: typeof window === 'undefined' ? undefined : window.localStorage,
  key: 'projetive-op-cache',
  serialize: (dados) => superjson.stringify(dados),
  deserialize: (texto) => superjson.parse(texto),
})

const router = createRouter({
  routeTree,
  context: { queryClient, trpcClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: MAX_IDADE_CACHE_MS,
        buster: VERSAO_CACHE,
        dehydrateOptions: {
          shouldDehydrateQuery: (q) =>
            q.state.status === 'success' && deveGuardarNoAparelho(q.queryKey),
        },
      }}
    >
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <RouterProvider router={router} />
      </TRPCProvider>
    </PersistQueryClientProvider>
  </StrictMode>,
)
